export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlRTE', function (AonConfig, OperatorService, $scope) {

    let ctrl = $scope.$parent.ctrl;
    const { PaymentFrequenciesLookup, PaymentMethodsLookup } = AonConfig.jsConstants;

    this.isCreditCardPayment = () => (
      _.get(ctrl.application, 'payment.type') === PaymentMethodsLookup.CREDIT_CARD
    );

    this.requiresBenefitsAccount = () => (
        _.get(ctrl.application, 'payment.type') !== PaymentMethodsLookup.BANK_ACCOUNT ||
        !_.get(ctrl.application, 'payment.benefits_same_account')
    );

    this.updatePaymentFrequencyOptions = () => {
      if (ctrl.application.payment.type === PaymentMethodsLookup.INVOICE) {
        // invoice payment - limited set of options
        const allowedFrequencies = [
          PaymentFrequenciesLookup.MONTHLY,
          PaymentFrequenciesLookup.QUARTERLY,
          PaymentFrequenciesLookup.HALF_YEARLY,
          PaymentFrequenciesLookup.YEARLY,
        ];

        this.paymentFrequencyOptions = ctrl.fieldsets.payment.frequency.choices
          .filter(([code]) => allowedFrequencies.includes(code));

        // If the frequency selected is no longer valid, clear it
        if (!allowedFrequencies.includes(ctrl.application.payment.frequency)) {
          _.set(ctrl.application, 'payment.frequency', undefined);
        }
      } else {
        // Reset to the full list of choices from the fieldsets
        this.paymentFrequencyOptions = ctrl.fieldsets.payment.frequency.choices;
      }
    }
    this.updatePaymentFrequencyOptions();

    $scope.$watch(
      'ctrl.application.payment.type',
      this.updatePaymentFrequencyOptions
    );

    $scope.$watch(
      'ctrl.application.policy.discount_code',
      // When employment group/discount code is changed, update pricing and sync with the operator filter
      () => {
        OperatorService.updateApplicantDependantFilters();
        ctrl.refetchPricing();
      }
    );
    this.debitDateDisabled = (date, mode) => {
        const dayOfWeek = date.getDay();
        const frequency = ctrl.application.payment.frequency;
        const isDirectDebit = ctrl.application.payment.type === PaymentMethodsLookup.BANK_ACCOUNT;
        if (frequency === PaymentFrequenciesLookup.FORTNIGHTLY && isDirectDebit) {
            return dayOfWeek !== 5;
        }
        return ctrl.debitDateDisabled(date, mode);
    };
    // ensure that available debit dates are updated when payment type is changed - parent
    // controller already watches payment frequency
    $scope.$watch('ctrl.application.payment.type', () => {
      ctrl.updateDebitDate();
    });
  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-rte.js